import React from 'react';
import { LICENSE_STATE_ACTIVE } from '@jira/platform__license-state/src/license-state.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraBottomRightCornerOutlet } from '@atlassian/jira-layout-controller/src/ui/bottom-right-corner/outlet/index.tsx';
import { useRovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { useLicenseStates } from '@atlassian/jira-tenant-context-controller/src/components/license-states/index.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { AiRovoButtonWrapperRefresh } from './AiRovoButtonWrapperRefresh.tsx';
import { useIsRovoAvailableForRoute } from './useIsRovoAvailableForRoute.tsx';

export const GlobalAiRovoButton = (): React.JSX.Element | null => {
	const isRovoAvailableForRoute = useIsRovoAvailableForRoute();
	const { data: rovoEntitlementData } = useRovoEntitlementResource();
	const showRovoButton = rovoEntitlementData?.isRovoLLMEnabled ?? false;
	const licenseState = useLicenseStates();
	const { hasSoftwareAccess } = useApplicationPermissions();

	const softwareAccessEnabled = licenseState.software === LICENSE_STATE_ACTIVE && hasSoftwareAccess;

	if (!isRovoAvailableForRoute || !showRovoButton) {
		return null;
	}

	if (!softwareAccessEnabled && fg('global_rovo_button_in_jira')) {
		return null;
	}

	/*
		This is a hybrid solution that allow us to do eager fetching of the panel modules on button hover,
		without having to props drill the panel placeholder component down the tree.
		https://hello.atlassian.net/wiki/spaces/AM3/pages/5585113512/LDR+Loading+Strategy+for+Rovo+Side+Panel+using+Entrypoints
	*/
	return (
		<JiraBottomRightCornerOutlet orderFromRight={0} id="floating-element-id">
			<AiRovoButtonWrapperRefresh />
		</JiraBottomRightCornerOutlet>
	);
};
